import React from 'react';
import { Link} from 'react-router-dom';
import {urlFor} from '../../utils/sanity/urlFor';
import ContactSection from '../../components/ContactSection';


function Portfolio({portfolioData}) {

  const portfolio = portfolioData

  return (
    <main className='max-w-screen min-h-screen px-6 xl:px-40 md:px-10'>
      {portfolio && portfolio.map((project) => (
        <React.Fragment key={project.id}>
          <article
            className="h-1/4 w-full pb-6 xl:pb-28 md:pb-20"
            key={project.id}
          > 
            {project.id % 2 === 0 ? (
              <div className='flex md:flex-row flex-col-reverse w-full gap-0 md:gap-32'>
                <div className="border-y border-gray-400 ml-0 md:ml-16 lg:pt-14 md:pt-6 pt-4 w-full md:w-1/3 flex flex-col justify-center">
                  <h2 className="heading-font text-2xl font-bold">
                    {project.projectTitle}
                  </h2>
                  <p className="main-font text-base my-5 md:my-2 pb-6 leading-7 tracking-wider">
                    {project.projectDescription}
                  </p>
                  <div className='mb-10'>
                    <Link
                      to={`project_description/${project.id}`}
                      className="hover:text-white text-xs tracking-widest btn5 border border-black px-4 py-4"
                    >
                      View Project
                    </Link>
                  </div>
                </div>
                <picture className="my-auto w-full md:w-1/2 pb-8 md:pb-0">
                  <img
                    src={urlFor(project.projectImage)}
                    alt="Sample Portfolio view"
                    className="block w-full h-auto"
                  />
                </picture>
              </div>
            ) : (
              <div className='flex md:flex-row flex-col w-full gap-0 md:gap-32'>
                <picture className="my-auto w-full md:w-1/2 pb-6 md:pb-0">
                  <img
                    src={urlFor(project.projectImage)}
                    alt="Sample Portfolio view"
                    className="block w-full h-auto"
                  />
                </picture>
                <div className="border-y border-gray-400 mr-0 md:mr-16 lg:pt-14 md:pt-6 pt-4 w-full md:w-1/3 flex flex-col justify-center">
                <h2 className="heading-font text-2xl font-bold">
                    {project.projectTitle}
                  </h2>
                  <p className="main-font text-base my-5 md:my-2 pb-6 leading-7 tracking-wider">
                    {project.projectDescription}
                  </p>
                  <div className='mb-10'>
                    <Link
                      to={`project_description/${project.id}`}
                      className="hover:text-white text-xs tracking-widest btn5 border border-black px-4 py-4"
                    >
                      View Project
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </article>
        </React.Fragment>
      ))}
      <ContactSection/>
    </main>
  );
}

export default Portfolio;